var React = require('react');

function Burgermenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round"},React.createElement("g",{"id":"burgermenu","transform":"translate(1.000000, 1.000000)","stroke":"#D6A444","strokeWidth":"2"},React.createElement("g",{"id":"Path-8"},[React.createElement("line",{"x1":"17","y1":"0.607142857","x2":"0","y2":"0.607142857","key":0}),React.createElement("line",{"x1":"17","y1":"7.89285714","x2":"0","y2":"7.89285714","key":1}),React.createElement("line",{"x1":"17","y1":"15.1785714","x2":"0","y2":"15.1785714","key":2})]))));
}

Burgermenu.defaultProps = {"viewBox":"0 0 19 18","version":"1.1"};

module.exports = Burgermenu;

Burgermenu.default = Burgermenu;
